<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;">
        <button-add @click="toAddPage" style="margin-right: 10px" v-if="permissionCodes.indexOf('022002001') !== -1"/>
        <button-delete @deleteSelection="deleteSelection" :value="'删除'" v-if="permissionCodes.indexOf('022002003') !== -1"/>
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @deleteLine="deleteLine" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/common/buttons/button-add";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Alarm";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import InputSelect from "../../../components/Input/InputSelect";

export default {
  components: {
    InputSelect,
    TableMain,
    InputSearch,
    ButtonAdd,
    ButtonDelete,
    Breadcrumb
  },
  name: "police-receiver",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "报警中心",
          name: "alarm-device-manage"
        },
        {
          value: "接警人管理"
        }
      ],
      searchPlaceholder: "接警人姓名/手机号",
      searchKey: "",
      deleteTipInfo: "是否确认删除该接警人？",
      tableHead: [
        {
          prop: "personName",
          label: "接警人姓名"
        },
        {
          prop: "personPhone",
          label: "手机"
        },
        {
          prop: "alarmType",
          label: "报警类别"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ["modify", "delete"],
      selectionArr: [],
      typeList: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    toAddPage() {
      this.$router.push({
        name: "police-receiver-add"
      });
    },
    getPage() {
      this.$axios
        .post(api.getAlarmHandleManPage, {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          searchKey: this.searchKey
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.code = v.personCode;
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    searchSelect(v) {
      this.pageNum = 1;
      this[v.key] = v.value;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },

    // 修改
    goToModifyPage(code) {
      this.$router.push({
        path: `/police_receiver_modify/${code}`
      });
    },

    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的接警人");
        return false;
      } else {
        this.$confirm("是否确认删除所选中的接警人？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteAlarmHandleManByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/AlarmManage/PoliceReceiver/PoliceReceiver.vue